import { Box, Typography, Divider } from "@mui/joy";
import { PackageOpen } from "lucide-react";
import type { ProductWithPrice } from "../types";

interface ProductItemProps {
    product: ProductWithPrice;
}

export function ProductItem({ product }: ProductItemProps) {
    const hasPrice = product.UnitPrice && product.UnitPrice > 0;

    return (
        <Box>
            <Box display={"flex"} mb={1.5} mt={1} alignItems={"center"} justifyContent={"space-between"}>
                <Box display={"flex"} flexBasis={"30%"} alignItems={"center"} gap={2}>
                    <PackageOpen size={20} color="gray" />
                    <Box>
                        <Typography level="body-sm" sx={{ fontWeight: 500 }}>
                            {product.ProductName}
                        </Typography>
                        <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                            {product.SupplierName || "No supplier assigned"}
                        </Typography>
                        <Typography level="title-md">{product.ItemCount} Nos</Typography>
                    </Box>
                </Box>
                <Box sx={{ width: 190 }}>
                    {hasPrice ? (
                        <>
                            <Typography level="title-sm">
                                ${product.UnitPrice.toFixed(2)} x {product.ItemCount}
                            </Typography>
                            <Typography level="title-lg">${(product.Total || 0).toFixed(2)}</Typography>
                        </>
                    ) : (
                        <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                            Price not available
                        </Typography>
                    )}
                </Box>
            </Box>
            <Divider />
        </Box>
    );
}
